module.exports = __webpack_public_path__ + "img/sest-1-sel.123e821e.svg";